export enum E_ObservationUnit {
    MLPerKg = "MDC_DIM_MILLI_L_PER_KG",
    MBar = "MDC_DIM_MILLI_BAR",
    ML = "MDC_DIM_MILLI_L",
    BeatPerMin = "MDC_DIM_BEAT_PER_MIN",
    RespPerMin = "MDC_DIM_RESP_PER_MIN",
    LitresPerMin = "MDC_DIM_X_L_PER_MIN",
    Percent = "MDC_DIM_PERCENT",
    Mmhg = "MDC_DIM_MMHG",
    Cm_H2O = "MDC_DIM_CM_H2O",
    DimLess = "MDC_DIM_DIMLESS",
}